import React, { ButtonHTMLAttributes, FC } from 'react';
import { css } from '@emotion/css';
import { Theme } from 'evcharging/app/themes';
import { CSSProperties } from '@emotion/serialize';
import useTheme from 'evcharging/hooks/useTheme';
import clsx from 'clsx';

type SubmitButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  CSSProperties & {
    fullWidth?: boolean;
  };

const Button: FC<SubmitButtonProps> = (props) => {
  const { fullWidth, height, ...rest } = props;
  const theme = useTheme();
  const styles = createStyles(theme, { fullWidth });
  return <button className={clsx(styles.root, css({ height }))} {...rest} />;
};

const createStyles = (theme: Theme, { fullWidth = false }: Partial<SubmitButtonProps>) => ({
  root: css`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${theme.colors.accent};
    border: none;
    border-radius: 6px;
    height: 56px;
    padding: 0 30px;
    vertical-align: middle;
    text-decoration: none;
    cursor: pointer;
    user-select: none;
    font-weight: 700;
    font-size: 18px;
    line-height: 150%;
    color: #fff;
    transition: all 0.15s ease-in-out;
    outline: none;
    ${fullWidth && 'width: 100%;'}
  `,
});

export default Button;
